import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 100%;
    padding: 10px;
`;

export const TextWrapper = styled.div`
    width: 100%;
`;

export const Text = styled.p`
    width: 100%;
    font-weight: 500;
    font-size: 1.2rem;
`;

export const LoaderWrapper = styled.div`
    display: grid;
    place-items: center;
`;
